export const SUPPORTED_LANGUAGES = ['en', 'fr', 'it'];
export const DEFAULT_LANGUAGE = 'it';

export function pickSupportedLanguage(
  preferredLanguages: readonly string[],
  supportedLanguages: readonly string[],
  fallback: string
): string {
  for (const preferred of preferredLanguages) {
    const exactMatch = supportedLanguages.find(
      (supported) => supported.toLowerCase() === preferred.toLowerCase()
    );
    if (exactMatch) {
      return exactMatch;
    }

    const baseLanguage = preferred.split('-')[0].toLowerCase();
    const baseMatch = supportedLanguages.find(
      (supported) => supported.split('-')[0].toLowerCase() === baseLanguage
    );
    if (baseMatch) {
      return baseMatch;
    }
  }
  return fallback;
}
